import { render, staticRenderFns } from "./FieldWorkplaceTableExpand.vue?vue&type=template&id=550f3cba&scoped=true"
import script from "./FieldWorkplaceTableExpand.vue?vue&type=script&lang=js"
export * from "./FieldWorkplaceTableExpand.vue?vue&type=script&lang=js"
import style0 from "./FieldWorkplaceTableExpand.vue?vue&type=style&index=0&id=550f3cba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550f3cba",
  null
  
)

export default component.exports